'use client';

import { Flags } from '@ametista-ai/api-schema';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useFlagOverrides } from './useFlagOverrides';

export function useFlag(flag: Flags, defaultValue: boolean = false) {
  const flags = useFlags();
  const [overrides] = useFlagOverrides();

  const override = overrides[flag];
  if (override !== undefined) {
    return override;
  }

  return flags?.[flag] ?? defaultValue;
}
